import { render, staticRenderFns } from "./iotlist.vue?vue&type=template&id=cc85b63a&scoped=true"
import script from "./iotlist.vue?vue&type=script&lang=js"
export * from "./iotlist.vue?vue&type=script&lang=js"
import style0 from "./iotlist.vue?vue&type=style&index=0&id=cc85b63a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc85b63a",
  null
  
)

export default component.exports